import React from "react";
import DefaultHead from "../DefaultHead";

const About: React.FC = () => {
  return (
    <div>
      <DefaultHead />
      <a href="#" className="termly-display-preferences">
        Consent Preferences
      </a>
      <p>
        <iframe
          style={{
            border: "none",
            background: "#eee",
            minWidth: "50%",
            maxWidth: "800px",
            height: "80%",
            minHeight: "600px",
            marginTop: "40px",
            padding: "60px",
          }}
          src="https://app.termly.io/policy-viewer/policy.html?policyUUID=d6e7d2a7-1251-48d7-9a81-c0e283c36818"
        />
      </p>
    </div>
  );
};

export default About;
